import { Field, ErrorMessage } from 'formik';
import cx from 'classnames';
import TextError from './TextError';
import { Icon, IconifyIcon } from '@iconify/react';
import styles from './FormikStyles.module.scss';

interface Props {
  className?: string;
  fullborder?: boolean;
  bottomborder?: boolean;
  icon?: IconifyIcon;
  label: string;
  name: string;
}

function Textarea(props: Props): JSX.Element {
  const { label, name, ...rest } = props;
  return (
    <div className={cx(styles.formControlTextArea, props.className)}>
      {props.label && (
        <label htmlFor={name}>
          {props.icon && <Icon icon={props.icon} />}
          {label}
        </label>
      )}
      <Field
        as='textarea'
        id={name}
        name={name}
        {...rest}
        className={cx({
          [`${styles.fullBorder}`]: props.fullborder,
          [`${styles.bottomBorder}`]: props.bottomborder,
        })}
      />
      <div className={styles.errorHintContainer}>
        <ErrorMessage name={name} component={TextError} />
      </div>
    </div>
  );
}

export default Textarea;
